import React from "react";

import "./toggle_admin.scss";  // 방금 만든 토글 스타일 (추가)
document.body.classList.add("type-"+process.env.REACT_APP_STYLE);

/**
 * 접근성/키보드 포커스/마우스 드래그 모두 되는 토글 스위치
 * props:
 *  - checked: boolean
 *  - onChange: (next:boolean) => void
 *  - disabled?: boolean
 *  - label?: string (시각적으로 숨김, 스크린리더용)
 */
export default function ToggleSwitch({ checked, onChange, disabled = false, label = "상태" }) {
  return (
    <label className={`adm-toggle ${checked ? "is-on" : ""} ${disabled ? "is-disabled" : ""}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
        aria-label={label}
      />
      <span className="track" aria-hidden="true">
        <span className="thumb" />
      </span>
    </label>
  );
}
